export interface CxMenuItem {
	label: string;
	routerLink?: string;
	icon?: string;
	items?: CxMenuItem[];
}

export const CX_PROPERTY_GROUP_SUBMENU: CxMenuItem[] = [
	{ label: "Helpline & FAQ's", icon: 'fa fa-info-circle fa-fw mr-1', routerLink: '/helpline-faq' },
	{ label: 'Announcements', icon: 'fa fa-newspaper-o fa-fw', routerLink: '/community-wall' },
	{ label: 'Event Calendar', icon: 'fa fa-calendar fa-fw mr-1', routerLink: '/event-calendar' },
	{ label: 'Property Group Documents', icon: 'fa fa-drivers-license-o fa-fw mr-1', routerLink: '/community-documents' },
];
